import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import '../../utils/assertions.es.js';
import { getClonedChild } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Text } from '../Text/Text.es.js';
import { Heading } from '../Heading/Heading.es.js';
import Button from '../Button/Button.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Banner as Banner$2, Overlay, TextWrapper, Image as Image$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Banner = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      rest = __objRest(_a, ["children"]);

  var childrenArray = React.Children.toArray(children);
  var title = getClonedChild(childrenArray, "Banner.Title");
  var content = getClonedChild(childrenArray, "Banner.Content");
  var action = getClonedChild(childrenArray, "Banner.Action");
  var image = getClonedChild(childrenArray, "Banner.Image");
  return (
    /* @__PURE__ */
    React.createElement(Banner$2, {
      ref: ref
    }, image,
    /* @__PURE__ */
    React.createElement(Overlay, __spreadValues({}, rest),
    /* @__PURE__ */
    React.createElement(TextWrapper, null, title, content), action))
  );
});
Banner.displayName = "Banner";

var Image = function Image(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement("picture", null, children,
    /* @__PURE__ */
    React.createElement(Image$1, {
      alt: alt,
      src: src
    }))
  );
};

Image.displayName = "Banner.Image";

var Source = function Source(_ref2) {
  var srcSet = _ref2.srcSet,
      media = _ref2.media;
  return (
    /* @__PURE__ */
    React.createElement("source", {
      srcSet: srcSet,
      media: media
    })
  );
};

Source.displayName = "Banner.Source";
var Title = styled(Heading).withConfig({
  componentId: "sc-1uyg2ye-0"
})([""]);
Title.defaultProps = {
  as: "h1",
  size: "md",
  contrast: "base",
  fontWeight: "bold"
};
Title.displayName = "Banner.Title";
var Content = styled(Text).withConfig({
  componentId: "sc-1uyg2ye-1"
})([""]);
Content.defaultProps = {
  size: "md"
};
Content.displayName = "Banner.Content";
var Action = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      props = __objRest(_b, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Button, __spreadValues({
      ref: ref,
      size: "md"
    }, props), children)
  );
});
Action.displayName = "Banner.Action";
var Banner$1 = Object.assign(Banner, {
  Title: Title,
  Content: Content,
  Action: Action,
  Image: Image,
  Source: Source
});
export { Banner$1 as default };